import React, { useRef } from 'react';

//  Module
import { getModuleComponents } from '../modules';

// interface
import { IModule, IModuleTile } from '../interfaces/interfaces';

interface PCTileProps {
  tile: IModuleTile;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modules: any;
  hideMenu: boolean;
}

function PCTile(props: PCTileProps): JSX.Element {
  const { tile, modules, hideMenu } = props;
  const { module: moduleName, props: tileProps } = tile;

  const modulesWComponents = getModuleComponents(modules);
  const module: IModule = modulesWComponents[moduleName];

  if (!module) {
    return <>Module not available ({moduleName})</>;
  }

  const moduleProps = { ...module.defaultProps, ...tileProps };

  moduleProps.className = moduleName;
  // isEditable is holding status for logged-in/-out users; non authenticated users are not able to edit tiles!
  moduleProps.isEditable = module.isEditable || false;
  moduleProps.hideMenu = hideMenu;
  moduleProps.resizeOptions = module.resizeOptions || [];
  moduleProps.tileRefId = tile.tileRefId;

  const tileRef = useRef<HTMLDivElement>(null);

  /* eslint-disable react/jsx-props-no-spreading */
  if (!module.component) {
    return <></>;
  }
  return (
    <div
      className={`tile-wrap ${moduleName} ${moduleProps.containerClassName || ''} ${
        tile.layout.static ? 'is-static' : ''
      }`}
      ref={tileRef}
    >
      <div className="content">
        <div aria-hidden="true" className="debug-info">
          #{tile.id} ref#{tile.tileRefId} - pos:{tile.layout.x}:{tile.layout.y} Edit:
          {moduleProps.isEditable ? 'yes' : 'no'}
        </div>
        <module.component {...moduleProps} tileId={tile.id} tileLayout={tile.layout} />
      </div>
    </div>
  );
}
export default PCTile;
